(() => {
  const query = window.matchMedia('(min-width: 990px)');

  const sync = () => {
    document.querySelectorAll('.footer-salut__col--menu').forEach((column) => {
      column.open = query.matches;
      const summary = column.querySelector('.footer-salut__summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', String(query.matches));
      if (query.matches) {
        summary.setAttribute('tabindex', '-1');
      } else {
        summary.removeAttribute('tabindex');
      }
    });
  };

  sync();
  query.addEventListener('change', sync);
})();
